import notificationActionTypes from './notificationActionTypes';
import {
    NotificationReducerAction,
    Notification,
} from './notificationRedux.types';

export const showNotification = ({
    message,
    variant = 'info',
    sx = null,
    autoHideDuration = 6000,
    autoHide = true,
}: Notification): NotificationReducerAction => {
    return {
        type: notificationActionTypes.SHOW_NOTIFICATION,
        payload: {
            message,
            variant,
            sx,
            autoHideDuration,
            autoHide,
        },
    };
};

export const closeNotification = (): NotificationReducerAction => {
    return {
        type: notificationActionTypes.CLOSE_NOTIFICATION,
    };
};
